export default __webpack_public_path__ + "assets/images/db92df585c810c7ad190c621533fd366.jpg";